import React from 'react';
import { Link } from 'react-router-dom';
import { Waypoint } from 'react-waypoint';
import { ElementLoader } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { DashboardAdminTranslation } from '../../constants';
import { DashboardAdminListState, DashboardSearchModel } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';

import styles from './list-renderer.scss';

interface ListRendererProps {
  listState: DashboardAdminListState;

  loadList: (model: DashboardSearchModel, startIndex: number) => void;
  deleteDashboard: (id: number, successMessage: string) => void;

  translation: DashboardAdminTranslation;
}

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, loadList, deleteDashboard, translation
}) => {

  const { fetching, requestedSearchModel, listItems, numberOfResults, deletingDashboards } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: DashboardSearchModel, startIndex?: number) => {

    if (startIndex !== undefined || !deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {

    if (fetching || !listItems || listItems.length === 0 || listItems.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, listItems.length);
  };

  const topToolbar = <div className="row">
    <h1 className="col-12">{translation.manage_dashboards_title}</h1>
  </div>;

  const rightToolbar = <Link
    id="dashboard-admin-add-new-button"
    to={routeConstants.dashboardAdminAdd}
    className="btn btn-primary">
    {translation.add_new}
  </Link>;

  return <>
    <SearchFilters
      topToolbar={topToolbar}
      rightToolbar={rightToolbar}
      filtersConfig={{ area: 'dashboardAdmin' }}
      hideDrawer={true}
      queryFilters={undefined}
      predefinedFilters={undefined}
      customFilters={undefined}
      defaultFilterValues={undefined}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div id="dashboards_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_dashboards
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          listItems={listItems}
          deletingDashboards={deletingDashboards}
          deleteDashboard={deleteDashboard}
          translation={translation} />
        : null}
      <Waypoint key="wpDashboardAdmin" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
